"use client";

import React from "react";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {useTheme} from "@mui/material/styles";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Skeleton from "@mui/material/Skeleton";
import NoResult from "@/components/errors/no-result";
import IsacoList from "@/app/(pages)/(general)/isaco/components/isaco-list";
import Pagination from "@/components/common/pagination/pagination";
import {useIsacoList} from "@/lib/api";
import IsacoSearch from "@/app/(pages)/(general)/isaco/components/isaco-search";

export default function IsacoView() {
    const router = useRouter();
    const pathname = usePathname();
    const searchParams = useSearchParams();
    const theme = useTheme();

    const searchText = searchParams.get("searchText") || "";
    const page = searchParams.get("page") || "1";

    const {data: isacoData, isLoading} = useIsacoList(searchText, page);

    const handleSearchPhraseChange = (phrase: string) => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("searchText", phrase);
        newParams.set("page", "1")

        router.push(`${pathname}?${newParams.toString()}`);
    };

    const handlePageChange = (newPage: number) => {
        const newParams = new URLSearchParams(searchParams.toString());
        newParams.set("page", newPage.toString());

        router.push(`${pathname}?${newParams.toString()}`);
    };

    const ItemLoading = () => (
        <Skeleton
            sx = {{borderRadius: theme.shape.borderRadius, mb: 1}}
            variant = "rectangular"
            width = "100%"
            height = {90}
        />
    );

    return (
        <Container sx = {{py: 6}} maxWidth = "lg" >
            <Paper elevation = {0} sx = {{p: 3}} >
                <IsacoSearch
                    isLoading = {isLoading}
                    searchPhrase = {searchText}
                    handleSearchPhraseChange = {handleSearchPhraseChange}
                />

                {isLoading ? (
                    <>
                        <ItemLoading />
                        <ItemLoading />
                        <ItemLoading />
                    </>
                ) : isacoData?.data?.length === 0 ? (
                    <NoResult />
                ) : (
                    <>
                        <IsacoList companiesList = {isacoData?.data || []} />
                        <Pagination
                            currentPage = {isacoData?.pageNumber || 0}
                            numberOfPages = {isacoData?.totalPages || 0}
                            changePageHandler = {handlePageChange}
                        />
                    </>
                )}
            </Paper >
        </Container >
    );
}
